import { Fragment, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button } from '../../../../common/html/button'
import { Element } from '../../../../common/html/element'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { selectCompanyInfoData, selectReportData } from '../store/slice'
import classes from './index.module.scss'
import { ReportItem } from './reportItem'
import { PopupCreateRequest } from './reportItem/PopupCreateRequest'

const BLOCK_REPORT_MAX_HEIGHT = 500

export const BlockReport = () => {
  const [currentReport, setCurrentReport] = useState({})

  const reportData = useSelector(selectReportData)
  const company = useSelector(selectCompanyInfoData)

  const [isOpenPopupRequest, setIsOpenPopupRequest] = useState(false)

  const createRequest = (report) => {
    setCurrentReport(report)
    setIsOpenPopupRequest(true)
  }

  const onClosePopupCheckData = () => {
    setIsOpenPopupRequest(false)
  }

  return (
    <Fragment>
      {reportData.length > 0 && (
        <ScrollComponent autoHeightMax={BLOCK_REPORT_MAX_HEIGHT} autoHeight>
          <div className={classes.blockReport}>
            {reportData.map((item, index) => (
              <Fragment key={index}>
                <Element
                  style={{ backgroundColor: '#F3F3F3', borderColor: '#d5d5d5' }}
                  className={classes.reportContainer}
                >
                  <div className="dFlex justifyContentBetween alignItemsCenter">
                    <Element
                      elementName="span"
                      style={{ color: '#191D25' }}
                      className="fw600"
                    >
                      {item.name}
                    </Element>
                  </div>
                  <div className={classes.reportItem}>
                    <ReportItem data={item} />
                  </div>
                  <div className="dFlex justifyContentEnd">
                    <Button
                      label="internationalPreview.CREATE_REQUEST"
                      style={{ backgroundColor: '#2C73E8', color: '#fff' }}
                      className={classes.blockBusinessServiceButton}
                      isI18n
                      action={() => createRequest(item)}
                    />
                  </div>
                </Element>
              </Fragment>
            ))}
          </div>
        </ScrollComponent>
      )}
      <PopupCreateRequest
        isOpen={isOpenPopupRequest}
        onClose={onClosePopupCheckData}
        company={company}
        currentReport={currentReport}
      />
    </Fragment>
  )
}
